export default __webpack_public_path__ + "static/5-5c376c8ad04fc59de52031ba79fa464c.jpeg";